import { createContext } from "react";
import { isModuleActionRestricted } from "../../common/EntitiesManagement";
import UnauthorizedModule from "./UnauthorizedModule";

// Publishes the current module Form so shared components (SearcherAndAdd,
// ActionButtons, ModalBackground) can self-enforce CREATE/DELETE/MODIFY.
// null = no module in scope -> components behave with no restriction.
export const ModuleContext = createContext(null);

// Wraps a route/page: if the module's ACCESS is restricted for the current
// user, renders the unauthorized page instead of the children.
export default function ModuleGuard({ form, children }) {
  if (form && isModuleActionRestricted(form, "ACCESS")) {
    return <UnauthorizedModule />;
  }
  return (
    <ModuleContext.Provider value={form ?? null}>
      {children}
    </ModuleContext.Provider>
  );
}
